import { render } from "./ProductInfo.vue?vue&type=template&id=653bed88&scoped=true&ts=true"
import script from "./ProductInfo.vue?vue&type=script&lang=ts"
export * from "./ProductInfo.vue?vue&type=script&lang=ts"

import "./ProductInfo.vue?vue&type=style&index=0&id=653bed88&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653bed88"]])

export default __exports__